export default "__VITE_ASSET__BDqXSFPF__"